import { useState } from 'react';
import { Alert, Button, Card, Form, Input, Space, Typography } from 'antd';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../database/config';
import { AdminCredentials } from '../types/auth';
import '../styles/admin.css';

function getAuthErrorMessage(code?: string): string {
  switch (code) {
    case 'auth/invalid-credential':
    case 'auth/wrong-password':
    case 'auth/user-not-found':
      return 'Неверный email или пароль.';
    case 'auth/invalid-email':
      return 'Некорректный формат email.';
    case 'auth/user-disabled':
      return 'Этот пользователь отключен.';
    case 'auth/too-many-requests':
      return 'Слишком много попыток входа. Попробуйте позже.';
    case 'auth/network-request-failed':
      return 'Ошибка сети. Проверьте интернет-соединение.';
    default:
      return 'Не удалось выполнить авторизацию.';
  }
}

function AdminLogin() {
  const [form] = Form.useForm<AdminCredentials>();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (values: AdminCredentials) => {
    setErrorMessage('');
    setSuccessMessage('');
    setIsLoading(true);

    try {
      await signInWithEmailAndPassword(auth, values.email, values.password);
      setSuccessMessage('Вход выполнен успешно.');
      navigate('/admin/dashboard');
    } catch (error) {
      const code = (error as { code?: string })?.code;
      setErrorMessage(getAuthErrorMessage(code));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <Card className="admin-login-card">
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
          <div className="admin-login-header">
            <Typography.Title level={4} style={{ margin: 0 }}>
              Вход в админ-панель
            </Typography.Title>
            <Typography.Text type="secondary">
              Введите ваши данные для входа
            </Typography.Text>
          </div>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            requiredMark={false}
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: 'Введите email.' },
                { type: 'email', message: 'Некорректный формат email.' },
              ]}
            >
              <Input placeholder="admin@example.com" />
            </Form.Item>

            <Form.Item
              label="Пароль"
              name="password"
              rules={[{ required: true, message: 'Введите пароль.' }]}
            >
              <Input.Password placeholder="********" />
            </Form.Item>

            <Button type="primary" htmlType="submit" loading={isLoading} block>
              Войти
            </Button>
          </Form>

          {errorMessage && <Alert type="error" showIcon message={errorMessage} />}
          {successMessage && (
            <Alert type="success" showIcon message={successMessage} />
          )}

          <div className="admin-login-footer">
            <Typography.Text type="secondary">
              Панель управления магазином
            </Typography.Text>
          </div>
        </Space>
      </Card>
    </div>
  );
}

export default AdminLogin;
